
import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";


export const ELEMENT_SELECTOR = '[data-add-element-classes]';
export const PLUGIN_NAME = 'AddElementClasses';



$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--add-element-classes" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__add-element-classes/index.js